import OptionsIndex from './index';

export default () => ({
  link: 'options',
  Handler: OptionsIndex,
});
